import React, { useState, useEffect } from "react";
import axios from "axios";
import Heroslider from "./components/Heroslider/Index";
import Overview from "./components/Description/Index";
import ProListing from "./components/Products/ProListing";
import GallerySlider from "./components/Gallery/GallerySlider";
import BusinessEnquiry from "./components/Forms/Enquiry";
import { API_BASE_URL } from "./Utils/useApi";
import { CircularProgress } from "@mui/material";

const Home = () => {
  const [homeData, setHomeData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHomeData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/home.php`);
        setHomeData(response.data);
      } catch (err) {
        setError(err.message || "An error occurred while fetching data");
      } finally {
        setLoading(false);
      }
    };

    fetchHomeData();
  }, []);

  if (loading)
    return (
      <div className="preloader flex-center">
        <CircularProgress size={24} />
      </div>
    );
  if (error) return <div>Error: {error}</div>;
  if (!homeData) return null;

  const {
    homeBanners,
    aboutUs,
    our_services,
    clientData,
    whyChooseUnitedCorp,
    gallery,
    corporate_brochure,
  } = homeData;

  return (
    <main>
      <Heroslider Data={homeBanners} ImageHeight={'820'} ImageWidth={'1920'}/>      
      <Overview Data={aboutUs} />
      <ProListing Data={our_services} Data2 ={whyChooseUnitedCorp} homePage={true} Button={true}/>     
      <GallerySlider Data={gallery} />
      <BusinessEnquiry corporate_brochure={corporate_brochure}/>     
    </main>    
  );
};

export default Home;
